import React from "react";
import { useDispatch } from "react-redux";
import { Card, Form, Row, Col, Button } from "react-bootstrap";
import { createInsight, updateInsight } from "../../features/insight/insightActions";

const InsightForm = ({ formData, setFormData, editId, setEditId, setShowForm }) => {
  const dispatch = useDispatch();

  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleContentChange = (index, field, value) => {
    const newContent = [...formData.insights_content];
    newContent[index][field] = value;
    setFormData({ ...formData, insights_content: newContent });
  };

  const handleAddContent = () => {
    setFormData((prev) => ({
      ...prev,
      insights_content: [...prev.insights_content, { heading: "", paragraph: "" }],
    }));
  };

  const handleRemoveContent = (index) => {
    const newContent = formData.insights_content.filter((_, i) => i !== index);
    setFormData({ ...formData, insights_content: newContent });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const data = new FormData();

    Object.keys(formData).forEach((key) => {
      if (key === "insights_content") {
        data.append(key, JSON.stringify(formData.insights_content));
      } else if (key === "insight_image" && formData[key]) {
        data.append(key, formData[key]);
      } else {
        data.append(key, formData[key]);
      }
    });

    if (editId) {
      dispatch(updateInsight({ id: editId, insightData: data }));
    } else {
      dispatch(createInsight(data));
    }

    setFormData({
      title: "",
      metaTitle: "",
      metaDescription: "",
      slug_url: "",
      brief_paragraph: "",
      insight_image: "",
      published_date: "",
      category: "",
      insights_content: [{ heading: "", paragraph: "" }],
    });
    setEditId(null);
    setShowForm(false);
  };

  return (
    <Card className="mb-4 shadow-sm" style={{ fontFamily: "arial" }}>
      <Card.Body>
        <h5 className="mb-3">{editId ? "✏️ Edit Insight" : "🆕 Create New Insight"}</h5>
        <Form onSubmit={handleSubmit}>
          <Row className="g-3">
            {["title", "metaTitle", "metaDescription", "slug_url", "brief_paragraph", "insight_image", "published_date", "category"].map((key) => (
              <Col md={6} key={key}>
                <Form.Group controlId={key}>
                  <Form.Label>{key.replace("_", " ")}</Form.Label>
                  {key === "insight_image" ? (
                    <Form.Control
                      type="file"
                      onChange={(e) => setFormData((prev) => ({ ...prev, [key]: e.target.files[0] }))}
                    />
                  ) : (
                    <Form.Control
                      type="text"
                      name={key}
                      value={formData[key]}
                      onChange={handleInputChange}
                      placeholder={`Enter ${key.replace("_", " ")}`}
                    />
                  )}
                </Form.Group>
              </Col>
            ))}

            {/* Dynamic blog content sections */}
            <Col xs={12}>
              <h6 className="fw-bold mt-3">📄 Insight Content Sections</h6>
              {formData.insights_content.map((content, index) => (
                <Card key={index} className="p-3 mb-3 bg-light border-0">
                  {content.heading !== undefined && (
                    <>
                      <Form.Group className="mb-2">
                        <Form.Label>Heading {index + 1}</Form.Label>
                        <Form.Control
                          type="text"
                          value={content.heading}
                          onChange={(e) => handleContentChange(index, "heading", e.target.value)}
                        />
                      </Form.Group>
                      <Form.Group>
                        <Form.Label>Paragraph {index + 1}</Form.Label>
                        <Form.Control
                          as="textarea"
                          value={content.paragraph}
                          onChange={(e) => handleContentChange(index, "paragraph", e.target.value)}
                        />
                      </Form.Group>
                    </>
                  )}
                  {content.quote !== undefined && (
                    <Form.Group>
                      <Form.Label>Quote</Form.Label>
                      <Form.Control
                        as="textarea"
                        value={content.quote}
                        onChange={(e) => handleContentChange(index, "quote", e.target.value)}
                      />
                    </Form.Group>
                  )}
                  <div className="text-end mt-2">
                    <Button variant="outline-danger" size="sm" onClick={() => handleRemoveContent(index)}>Remove</Button>
                  </div>
                </Card>
              ))}
              <Button variant="outline-primary" size="sm" onClick={handleAddContent}>Add Section</Button>
            </Col>

            <Col xs={12}>
              <Button type="submit" variant="primary" className="mt-3">
                {editId ? "Update Insight" : "Create Insight"}
              </Button>
            </Col>
          </Row>
        </Form>
      </Card.Body>
    </Card>
  );
};

export default InsightForm;
